import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatAmount } from '../../utils/formatAmount';

import useReport from './useReport';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)' // This sets the overlay color
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ExpenseSummaryReport = () => {

  const {reportData, getExpenseSummaryReport} = useReport() 

  //const {receiptIssues, setReceiptIssues, getIncompleteIssue, updateDoneStatus} = useReceiptIssue()
  const [imageUrls, setImageUrls] = useState()
  const [modalIsOpen, setModalIsOpen] = useState(false);

/*   const handleReceiptClick = (receipts) => {
    if(receipts){
      const receiptUrls = receipts.map((receipt) => (receipt.imageUrl))
      setImageUrls(receiptUrls)
    }
  } */

  const openImageSlider = async (receipts) => {
    if(receipts){
      const receiptUrls = receipts.map((receipt) => (receipt.imageUrl))
      setImageUrls(receiptUrls)
    }
    setModalIsOpen(true)
  };

  const closeImageSlider = () =>{
    setModalIsOpen(false)
  }

/*   const doneIconClick = async (receiptId) => {
    const result = await updateDoneStatus({receiptId})
    if(result){
      setReceiptIssues(prevState => prevState.filter((data) => data.id != receiptId));
      toast.success("Update Successfully")
    }else{
      toast.error("Update Fail")
    }
  } */
  
  function Row({expense}) {
    const [open, setOpen] = React.useState(false);
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {expense?.month}
          </TableCell>
          <TableCell>{formatAmount(expense?.totalAmountInMonth)}</TableCell>
          <TableCell/>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableBody>
                  {expense.options.map((option) => {
                    return (
                      <TableRow key={option.uuid}>
                        <TableCell width='20%'> {option.option}</TableCell>
                        <TableCell>{`${formatAmount(option.amountForOption)} (${formatAmount(option.amountForOption*100/expense.totalAmountInMonth)}%)`}</TableCell>
                      </TableRow>
                    );
                  })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  useEffect(() => {
    console.log(reportData)
  },[reportData])

  useEffect(() => {
    getExpenseSummaryReport()
  },[])

  /* useEffect(() => {
    console.log(receiptIssues)
  },[receiptIssues]) */
  
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow className='bg-indigo-600'>
            <TableCell width="5%" />
            <TableCell width="15%" style={{ color: 'white', fontWeight : 'bold'}} >Month</TableCell>
            <TableCell width="15%" style={{ color: 'white', fontWeight : 'bold'}}>Total Expense (THB)</TableCell>
            <TableCell width="65%"/>
          </TableRow>
        </TableHead>
        <TableBody>
          {reportData && reportData.map((expense) => (
            <Row key={expense.id} expense={expense} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ExpenseSummaryReport